import { Route, Switch } from 'react-router-dom';
import { ForgotPassword } from 'pages/authentication/ForgotPassword';
import { Login } from 'pages/authentication/Login';
import { ResetPassword } from 'pages/authentication/ResetPassword';
import { ROUTES } from 'config/routes';

export function LoginRouter() {
    return (
        <Switch>
            <Route exact path={ROUTES.accounts.forgotPassword}>
                <ForgotPassword />
            </Route>
            <Route exact path={ROUTES.accounts.resetPassword}>
                <ResetPassword />
            </Route>
            <Route>
                <Login />
            </Route>
        </Switch>
    );
}
